
const digest = 'ebb3f6652cce9293a87008ed62be05d936a83c80f457243056abfba1fa939d72';
const classes = {"wrapper":"_wrapper_1hipd_1","date":"_date_1hipd_6","item":"_item_1hipd_15","content":"_content_1hipd_23","medicament":"_medicament_1hipd_32","title":"_title_1hipd_37","moreInfo":"_moreInfo_1hipd_44","moreInfoItem":"_moreInfoItem_1hipd_51","text":"_text_1hipd_60","controls":"_controls_1hipd_63","link":"_link_1hipd_74"};
const css = `._wrapper_1hipd_1 {
  display: flex;
  flex-direction: column;
  position: relative;
}
._wrapper_1hipd_1 ._date_1hipd_6 {
  font-weight: 600;
  font-size: 14px;
  padding: 18px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #f9fdff;
  color: #000000;
}
._wrapper_1hipd_1 ._item_1hipd_15 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._medicament_1hipd_32 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._medicament_1hipd_32 ._title_1hipd_37 {
  font-weight: 500;
  min-width: 255px;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._medicament_1hipd_32 ._title_1hipd_37 span {
  font-weight: 400;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._moreInfo_1hipd_44 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._moreInfo_1hipd_44 ._moreInfoItem_1hipd_51 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._moreInfo_1hipd_44 ._moreInfoItem_1hipd_51 ._title_1hipd_37 {
  color: grey;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._content_1hipd_23 ._moreInfo_1hipd_44 ._moreInfoItem_1hipd_51 ._text_1hipd_60 {
  color: #000000;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._controls_1hipd_63 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}
._wrapper_1hipd_1 ._item_1hipd_15 ._controls_1hipd_63 ._link_1hipd_74 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  